import { render, staticRenderFns } from "./Indication.vue?vue&type=template&id=487b6770&scoped=true"
import script from "./Indication.vue?vue&type=script&lang=js"
export * from "./Indication.vue?vue&type=script&lang=js"
import style0 from "./Indication.vue?vue&type=style&index=0&id=487b6770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b6770",
  null
  
)

export default component.exports